import React from 'react'
import { Container } from './styles'
import { useRadiologyHealthProcedures } from '~/context'
import { EMedicalViews, createSelectedPeriodFrom, PeriodOfTime } from '~/interfaces/timeline'
import {
  TimelinePeriodSelector,
  MedicalViewSelector,
  MedicalEventTypeFilter,
  CalendarFilter
} from '~/components/shared/medicalViews'
import { filterHealthProceduresTypesRadiology } from '~/constants/healthProceduresTypes'
import { SearchHealthProcedure } from '~/components/healthProcedures/SearchHealthProcedure'
import { Inline } from '~/styles'

export const RadiologyHeader = (): JSX.Element => {
  const {
    selectedPeriod,
    displayedHealthProcedures,
    updateSelectedPeriod,
    handleFilterHealthProceduresPerDate,
    hasDateFiltersActive,
    dateFiltersActive,
    hasTypeFiltersActive,
    typeFiltersActive,
    handleFilterHealthProceduresPerType,
    filterHealthProceduresByTerm
  } = useRadiologyHealthProcedures()

  return (
    <Container>
      <Inline width="100%" justifyContent="space-between">
        <TimelinePeriodSelector
          value={selectedPeriod.period}
          onChange={value => updateSelectedPeriod({ ...createSelectedPeriodFrom(value as PeriodOfTime) })}
        />

        <Inline spacing="0.5rem">
          <MedicalViewSelector selectedMedicalView={EMedicalViews.RADIOLOGY} isActive />

          <MedicalEventTypeFilter
            options={filterHealthProceduresTypesRadiology}
            selected={typeFiltersActive}
            isActive={hasTypeFiltersActive}
            onChange={handleFilterHealthProceduresPerType}
          />

          <CalendarFilter
            dates={dateFiltersActive}
            isActive={hasDateFiltersActive}
            onChange={handleFilterHealthProceduresPerDate}
          />
        </Inline>
      </Inline>
      <SearchHealthProcedure options={displayedHealthProcedures} handleSearch={filterHealthProceduresByTerm} />
    </Container>
  )
}
